import * as WELLNESS_ACTIONS from './actions';

import asyncWrapper from '../../../helpers/asyncWrapper';
import { handleError } from '../../../helpers/errorHandlers';
import { getWellnessFlatAnwerQuestionPairs as getFlatAnwerQuestionPairs } from '../../../helpers/questionnaireUtils';

import { wellnessQuestionnairesRoute, wellnessRecommendationsRoute } from '../../../constants/apiRoutes';

export function loadWellnessQuestionnaires() {
  return {
    types: [
      WELLNESS_ACTIONS.LOAD_WELLNESS_QUIZ_START,
      WELLNESS_ACTIONS.LOAD_WELLNESS_QUIZ_SUCCESS,
      WELLNESS_ACTIONS.LOAD_WELLNESS_QUIZ_FAIL
    ],
    promise: async ({ client }) => {
      const [res, err] = await asyncWrapper(client.get(wellnessQuestionnairesRoute));
      handleError(err);
      return res;
    },
  };
}

export function loadWellnessRecommendations() {
  return {
    types: [
      WELLNESS_ACTIONS.LOAD_WELLNESS_RECOMMENDATIONS_START,
      WELLNESS_ACTIONS.LOAD_WELLNESS_RECOMMENDATIONS_SUCCESS,
      WELLNESS_ACTIONS.LOAD_WELLNESS_RECOMMENDATIONS_FAIL
    ],
    promise: async ({ client }) => {
      const [res, err] = await asyncWrapper(client.get(wellnessRecommendationsRoute));
      handleError(err);
      return res;
    },
  };
}

export function sendWellnessAnswers(questionnaires) {
  return {
    types: [
      WELLNESS_ACTIONS.SEND_WELLNESS_ANSWERS_START,
      WELLNESS_ACTIONS.SEND_WELLNESS_ANSWERS_SUCCESS,
      WELLNESS_ACTIONS.SEND_WELLNESS_ANSWERS_FAIL
    ],
    promise: async ({ client }) => {
      const body = Object.keys(questionnaires).reduce((acc, qKey) => {
        const q = questionnaires[qKey];

        return {
          ...acc,
          [qKey]: getFlatAnwerQuestionPairs(q)
        };
      }, {});

      const [res, err] = await asyncWrapper(client.patch(wellnessQuestionnairesRoute, body));
      handleError(err);
      return res;
    },
  };
}
